export const CARE_SOURCE_TYPES = Object.freeze({
  TYPED_LONG_NOTE: 'typed_long_note',
  QUICK_CHECK_IN: 'quick_check_in',
  DICTATED_TEXT: 'dictated_text',
  FILE_IMPORT: 'file_import',
  SCREENSHOT: 'screenshot',
  OCR_TEXT: 'ocr_text',
  DOCTOR_NOTE: 'doctor_note',
  PROFILE_DOCUMENT: 'profile_document',
  CARE_KNOWLEDGE: 'care_knowledge',
  CARE_KNOWLEDGE_DOCUMENT: 'care_knowledge_document',
  CARE_KNOWLEDGE_PHOTO: 'care_knowledge_photo',
  CARE_KNOWLEDGE_SCREENSHOT: 'care_knowledge_screenshot',
  INCOMING_MESSAGE: 'incoming_message',
  UNKNOWN: 'unknown',
});

const SOURCE_TYPE_ALIASES = Object.freeze({
  long_note: CARE_SOURCE_TYPES.TYPED_LONG_NOTE,
  text: CARE_SOURCE_TYPES.TYPED_LONG_NOTE,
  quick_log: CARE_SOURCE_TYPES.QUICK_CHECK_IN,
  voice: CARE_SOURCE_TYPES.DICTATED_TEXT,
  email: CARE_SOURCE_TYPES.INCOMING_MESSAGE,
  message: CARE_SOURCE_TYPES.INCOMING_MESSAGE,
  import_file: CARE_SOURCE_TYPES.FILE_IMPORT,
  import: CARE_SOURCE_TYPES.FILE_IMPORT,
  image_ocr: CARE_SOURCE_TYPES.OCR_TEXT,
  medical_note: CARE_SOURCE_TYPES.DOCTOR_NOTE,
  doctors_note: CARE_SOURCE_TYPES.DOCTOR_NOTE,
  medication_document: CARE_SOURCE_TYPES.DOCTOR_NOTE,
  medication_doc: CARE_SOURCE_TYPES.DOCTOR_NOTE,
  medication_list: CARE_SOURCE_TYPES.DOCTOR_NOTE,
  profile_doc: CARE_SOURCE_TYPES.PROFILE_DOCUMENT,
  profile_support_document: CARE_SOURCE_TYPES.PROFILE_DOCUMENT,
  knowledge: CARE_SOURCE_TYPES.CARE_KNOWLEDGE,
  care_info: CARE_SOURCE_TYPES.CARE_KNOWLEDGE,
  care_knowledge_doc: CARE_SOURCE_TYPES.CARE_KNOWLEDGE_DOCUMENT,
  care_knowledge_file: CARE_SOURCE_TYPES.CARE_KNOWLEDGE_DOCUMENT,
  care_knowledge_image: CARE_SOURCE_TYPES.CARE_KNOWLEDGE_PHOTO,
});

const cleanTypeToken = (value = '') => (
  String(value || '').trim().toLowerCase().replace(/[\s-]+/g, '_')
);

export const normalizeCareSourceType = (value = CARE_SOURCE_TYPES.UNKNOWN) => {
  const token = cleanTypeToken(value);
  if (!token) {
    return CARE_SOURCE_TYPES.UNKNOWN;
  }

  return SOURCE_TYPE_ALIASES[token]
    || (Object.values(CARE_SOURCE_TYPES).includes(token) ? token : CARE_SOURCE_TYPES.UNKNOWN);
};
